<template>
  <div class="deleted-staff">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <!-- Change lg to 9 if another component is placed on the right  -->
        <v-card class="mx-4 mb-4">
          <v-card-title class="mb-1">
            Deleted Staff
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            
          </v-card-title>

          <v-data-table
            :headers="headers"
            dense
            :items="staff"
            :search="search"
            :options.sync="options"
            :items-per-page="15"
            :multi-sort="true"
            :server-items-length="pagination.totalCount"
            class="row-pointer"
          >
            <template v-slot:item.image="{ item }">
              <v-avatar width="30" height="30" class="mb-2">
                <img :src="item.image" />
              </v-avatar>
            </template>
            <template v-slot:item.full_name="{ item }">
              <h5>{{ item.full_name }}</h5>
            </template>
            <template v-slot:item.action="{ item }">
                <div class="my-2">
                    <v-btn
                        rounded
                        outlined
                        color="primary"
                        :disabled="isLoading"
                        @click="triggerRestore(item)"
                    >
                        Restore
                        <v-icon class="ml-2">
                            mdi-backup-restore
                        </v-icon>
                    </v-btn>
                </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    <v-snackbar v-model="snackbar.visible">
        {{ snackbar.text }}
        <template>
            <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
        </template>
    </v-snackbar>
    </v-row>
        <DeleteConfirmationDialog
        :visible="showConfirmationDialog"
        title="Restore this deleted staff ?"
        description="Are you sure you want to continue? Proceeding will restore this staff's records."
        confirmationButtonText="Proceed"
        @deleteObject="restoreDeletedStaff"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog.vue";

export default {
  name: "DeletedStaff",
  components: {
	DeleteConfirmationDialog
  },
  data() {
    return {
      search: "",
      options: {},
      pagination: {
        totalCount: 0,
        url: endpoints.deletedStaff,
      },
      headers: [
        { text: "Photo", value: "image", align: "center", sortable: false },
        { text: "Name", value: "full_name", align:"center" },
        { text: "Phone Number", value: "phone", align: "center", sortable: false },
        { text: "Action", value: "action", align: "center", sortable: false },
      ],
      staff: [],
      selected_id: null,
      snackbar: {
        visible: false,
        text: "",
      },
      showConfirmationDialog: false,
    };
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser","isLoading"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    // get all staff from the server
    async getAllStaff() {
      var response;
      var url = this.pagination.url;
      // if search query exists, add to the url as a GET param w/o disturbing other params
      if (this.search) {
        url += (url.split("?")[1] ? "&" : "?") + "search=" + this.search;
      }

      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: url,
        responseVar: response,
      });

      if (response) {
        this.staff = response.results;
        this.pagination.totalCount = response.count;
        this.pagination.nextUrl = response.next;
      }
    },

    triggerRestore(item){
        this.selected_id = item.id;
        this.showConfirmationDialog = true;
    },

    async restoreDeletedStaff(confirm) {
        if(confirm) {
            var url = endpoints.deletedStaff + `${this.selected_id}/`
            var post_body = { 'soft_deleted' : false }
            var response = await api.call(this.apiEssentials, url, api.Methods.PATCH, post_body)
            if(response){
                this.snackbar.text = "Successfully restored the deleted staff!"
                this.snackbar.visible = true
                this.getAllStaff()
                this.showConfirmationDialog = false
                this.selected_id = null
            }
        }
        else
            this.showConfirmationDialog = false
    },

    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

  },
  watch: {
    options: {
      async handler() {
        this.pagination.url =
          endpoints.deletedStaff + "?page=" + this.options.page;
        if (this.options.sortBy.length > 0) {
          // get url var
          var params = "&ordering=";
          // iterate over sortBy options and add sortby and sortdesc seperated with commas
          for (var sortOption in this.options.sortBy) {
            params +=
              (this.options.sortDesc[sortOption] ? "" : "-") +
              this.options.sortBy[sortOption];
            if (sortOption != this.options.sortBy.length - 1) params += ",";
          }
          this.pagination.url += params;
        }
        this.getAllStaff();
      },
    },
    search: {
      async handler() {
        this.options.page = 1;
        var searched = this.search;
        var self = this;
        setTimeout(function () {
          if (searched == self.search) {
            self.getAllStaff();
          }
        }, 500);
      },
    },
    created() {
    },
  },
};
</script>